// Routes accessible without login that should still show the bottom navbar
const PUBLIC_NAV_PREFIXES = ['/sites', '/home', '/news'];

// Full-screen flows (top-up form, payment/top-up animation) that must not show
// the bottom navbar. Matched per path segment so e.g. `/payments-history` is
// not affected.
const HIDDEN_NAV_ROUTE_ROOTS = ['/topup', '/payment'];

const isUnderRoot = (pathname: string, root: string): boolean =>
  pathname === root || pathname.startsWith(`${root}/`);

export const isNavbarVisible = (pathname: string, isLoggedIn: boolean) => {
  if (HIDDEN_NAV_ROUTE_ROOTS.some((root) => isUnderRoot(pathname, root))) {
    return false;
  }

  return (
    isLoggedIn ||
    PUBLIC_NAV_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
};
